import React from 'react';
import IconButton from '@mui/joy/IconButton';
import { useColorScheme } from '@mui/joy/styles';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';

const ColorSchemeToggle: React.FC = () => {
  const { mode, setMode } = useColorScheme();
  const isDark = mode === 'dark';
  return (
    <IconButton
      size="sm"
      variant="outlined"
      color="neutral"
      aria-label={isDark ? 'Modo claro' : 'Modo oscuro'}
      onClick={() => setMode(isDark ? 'light' : 'dark')}
    >
      {isDark ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
    </IconButton>
  );
};

export default ColorSchemeToggle;
